module.exports = __webpack_public_path__ + "img/267b.dbe63d2.svg";